var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlotsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92308 7.19231C5.92308 8.82795 4.59718 10.1539 2.96154 10.1539C1.3259 10.1539 0 8.82795 0 7.19231C0 5.55667 1.3259 4.23077 2.96154 4.23077C4.59718 4.23077 5.92308 5.55667 5.92308 7.19231Z",
    fill: "#E72649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0383 5.07692C7.43079 5.07692 6.86633 5.26135 6.39681 5.57526C6.62866 6.06774 6.76907 6.61179 6.76907 7.1923C6.76907 8.21949 6.3578 9.14781 5.69702 9.8323C6.23851 10.538 7.08043 11 8.0383 11C9.67394 11 10.9998 9.67412 10.9998 8.03848C10.9998 6.40284 9.67394 5.07694 8.0383 5.07694V5.07692Z",
    fill: "#E72649"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53856 3.38462H3.38471C3.38471 2.36923 2.92612 1.46725 2.21531 0.846154H2.96164C5.08722 0.846154 6.88102 2.28036 7.43537 4.23077H8.30778C7.73228 1.80908 5.55682 0 2.96178 0H0.000244141V0.846154C1.39981 0.846154 2.53871 1.98505 2.53871 3.38462H2.53856Z",
    fill: "#E72649"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotsActive);
export default __webpack_public_path__ + "static/media/slots-active.561d62cf6659bb81c0a15d48831e2830.svg";
export { ForwardRef as ReactComponent };